import type { BehaviourBreakdownLine, BehaviourMetric } from '@chukua/common';

/** Words, not a verdict: the weights behind the number are still placeholders, so the band only says how many incidents there were. */
export function behaviourBand(score: number): string {
  if (score >= 90) return 'Few incidents';
  if (score >= 75) return 'Some incidents';
  return 'Many incidents';
}

const METRIC_LABELS: Record<BehaviourMetric, string> = {
  overspeed_events: 'Speeding over the limit',
  overspeed_minutes: 'Time over the limit',
  idling_events: 'Idling with the engine running',
  idling_minutes: 'Time idling',
  off_route_events: 'Off the planned route',
  unsafe_stop_events: 'Stopped somewhere unsafe',
  stopped_events: 'Standing still too long',
};

function isMinutes(metric: BehaviourMetric): boolean {
  return metric.endsWith('_minutes');
}

function formatTotal(line: BehaviourBreakdownLine): string {
  if (isMinutes(line.metric)) return `${Math.round(line.total)} min`;
  return `${line.total} ${line.total === 1 ? 'time' : 'times'}`;
}

/** "Speeding over the limit: 4 times · −2 points". Penalties are shown to the point; the stored value keeps its decimals. */
export function describeBreakdownLine(line: BehaviourBreakdownLine): string {
  const points = Math.max(1, Math.round(line.penalty));
  return `${METRIC_LABELS[line.metric]}: ${formatTotal(line)} · −${points} ${points === 1 ? 'point' : 'points'}`;
}

/** The day a score was worked out for; `asOf` is a calendar date, so it is read as UTC to never slide to the day before. */
export function formatScoreDate(asOf: string): string {
  return new Date(`${asOf}T00:00:00Z`).toLocaleDateString('en-GB', { day: 'numeric', month: 'short', year: 'numeric', timeZone: 'UTC' });
}
